import { Col, DatePicker, Form, Input, Modal, Row, message } from "antd";
import InputField from "../../atoms/InputField";
import React, { useState } from "react";
import SelectOptn from "../../atoms/SelectOption";
import { useDispatch } from "react-redux";
import SubmitButton from "../../atoms/Buttons/SubmitButton";

const AddForm = (props) => {
  const {
    isVisible,
    setIsVisible,
    setShowLoader,
    name,
    payload,
    list,
    formFields,
    successMessage,
    onSuccess,
  } = props;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [collapseClass, setCollapseClass] = useState("");

  const closeModal = () => setIsVisible(false);

  const onFinish = (values) => {
    setShowLoader(true);
    dispatch(list(payload(values))) // call thunk
      .unwrap()
      .then(() => {
        setCollapseClass("hide");
        message.success(successMessage);
        form.resetFields();
        setShowLoader(false);
        closeModal();
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch(() => {
        setShowLoader(false);
      });
  };

  const handleSubmit = () => {
    form.submit();
  };

  return (
    <Modal
      className="custom-modal"
      title={name}
      open={isVisible}
      onCancel={closeModal}
      footer={[
        <SubmitButton
          key="cancel"
          type="primary"
          className="btn px-5 py-2 defaultWhiteBtn rounded-lg"
          submitName="Cancel"
          onClick={closeModal}
        />,
        <SubmitButton
          key="sbmit"
          type="primary"
          htmlType="submit"
          submitName="Submit"
          className="btn px-5 py-2 defaultbutton rounded-lg"
          onClick={handleSubmit}
        />,
      ]}
      destroyOnClose
    >
      <div className="">
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Row gutter={[12, 12]}>
            {formFields &&
              formFields?.map((field, index) => {
                if (!field?.isVisible) return null;
                return (
                  <Col key={index} sm={24}>
                    <Form.Item
                      className="m-0"
                      label={
                        <>
                          {field?.label}
                          {field?.rules?.some((rule) => rule.required) && (
                            <span
                              className="postAstric"
                              style={{ color: "#B12A26" }}
                            >
                              *
                            </span>
                          )}
                        </>
                      }
                      name={field?.name}
                      rules={field?.rules}
                    >
                      {field.type === "input" ? (
                        <InputField placeholder={field?.placeholder} />
                      ) : field.type === "select" ? (
                        <SelectOptn
                          size={field?.size}
                          placeholder={field?.placeholder}
                          allowClear={field?.allowClear}
                          options={field?.options}
                          mode={field?.mode}
                          onChange={(value) => {
                            if (field.onchnge) {
                              form.setFieldValue(field.name, value);
                            }
                          }}
                        />
                      ) : field.type === "datepicker" ? (
                        <DatePicker
                          showTime={field.showTime ?? true}
                          format={field.format}
                          picker={field.picker ?? "date"} // default to "date"
                          onChange={(date, dateString) => {
                            // call the field handler if it exists
                            if (field.onchnge)
                              form.setFieldValue(field.name, dateString);
                          }}
                        />
                      ) : field.type === "custom" ? (
                        <React.Fragment key={field.name}>
                          {field.render()}
                        </React.Fragment>
                      ) : field.type === "rangePicker" ? (
                        <DatePicker.RangePicker
                          showTime={false}
                          format={field?.format ?? "YYYY-MM-DD HH:mm"}
                          onChange={(dates) => {
                            form.setFieldValue(field.name, dates); // store dayjs objects
                          }}
                        />
                      ) : field.type === "textarea" ? (
                        <Input.TextArea
                          placeholder={field?.placeholder}
                          rows={4}
                          onChange={(e) =>
                            form.setFieldValue(field.name, e.target.value)
                          }
                        />
                      ) : (
                        ""
                      )}
                    </Form.Item>
                  </Col>
                );
              })}
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default AddForm;
